// utilities
import { jsx as _jsx } from "react/jsx-runtime";
import { buildTableOfContents } from "../../utils";
// components
import { SectionDiv, Typography } from "../../components";
import TableOfContentsSection from "./Section";
export default function getTableOfContents(sections = []) {
    const toc = buildTableOfContents(sections);
    return [
        {
            name: "Table of Contents",
            id: "toc",
            child: /*#__PURE__*/ _jsx("div", {
                id: `table-of-contents-title`,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "title",
                    children: "Table of Contents"
                })
            })
        },
        ...toc.map((section, index)=>({
                id: `toc-section-${index}`,
                name: "",
                pageBreak: index === toc.length - 1 ? "after" : "",
                child: /*#__PURE__*/ _jsx(SectionDiv, {
                    children: /*#__PURE__*/ _jsx(TableOfContentsSection, {
                        section: section,
                        major: index + 1,
                        showSubSection: true
                    })
                })
            })).filter(Boolean)
    ];
}
